// extracted by mini-css-extract-plugin
export default {"verticalIcon":"verticalIcon--_2qOH"};